var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useOkapiKy } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { fetchLibraryById } from "../api/libraryService";
import { fetchCurrentUser } from "../api/userService";
import { LibraryDtoTypeEnum } from "../types/Api";
import { getViewAsLibraryName } from "../utils/viewAsLibrary";
import { useViewAsLibraryId } from "./useViewAsLibraryId";
var EMPTY_ACTIVE_LIBRARY = {
    activeLibraryId: "",
    activeLibraryName: "",
    isNationalLibrary: false,
    canRequestCopies: false,
};
var ACTIVE_LIBRARY_STALE_TIME = 60 * 60 * 1000;
// the acting library must be the one getHeaders sends as X-View-As-Library, or agenda decisions target a different library than the API
export var useIsNationalLibrary = function () {
    var kyInstance = useOkapiKy();
    var viewAsLibraryId = useViewAsLibraryId();
    var _a = useQuery(["active-library-report-context", viewAsLibraryId !== null && viewAsLibraryId !== void 0 ? viewAsLibraryId : ""], function () { return __awaiter(void 0, void 0, void 0, function () {
        var library_1, currentUser, activeLibraryId, library;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    if (!viewAsLibraryId) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchLibraryById(kyInstance, viewAsLibraryId)];
                case 1:
                    library_1 = _k.sent();
                    return [2 /*return*/, {
                            activeLibraryId: viewAsLibraryId,
                            activeLibraryName: (_b = (_a = library_1.name) !== null && _a !== void 0 ? _a : getViewAsLibraryName()) !== null && _b !== void 0 ? _b : "",
                            isNationalLibrary: library_1.type === LibraryDtoTypeEnum.NATIONAL,
                            canRequestCopies: (_c = library_1.canRequestCopies) !== null && _c !== void 0 ? _c : false,
                        }];
                case 2: return [4 /*yield*/, fetchCurrentUser(kyInstance)];
                case 3:
                    currentUser = _k.sent();
                    activeLibraryId = (_e = (_d = currentUser === null || currentUser === void 0 ? void 0 : currentUser.activeOrganization) === null || _d === void 0 ? void 0 : _d.sourceId) !== null && _e !== void 0 ? _e : "";
                    if (!activeLibraryId)
                        return [2 /*return*/, EMPTY_ACTIVE_LIBRARY];
                    return [4 /*yield*/, fetchLibraryById(kyInstance, activeLibraryId)];
                case 4:
                    library = _k.sent();
                    return [2 /*return*/, {
                            activeLibraryId: activeLibraryId,
                            activeLibraryName: (_h = (_f = library.name) !== null && _f !== void 0 ? _f : (_g = currentUser === null || currentUser === void 0 ? void 0 : currentUser.activeOrganization) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : "",
                            isNationalLibrary: library.type === LibraryDtoTypeEnum.NATIONAL,
                            canRequestCopies: (_j = library.canRequestCopies) !== null && _j !== void 0 ? _j : false,
                        }];
            }
        });
    }); }, { staleTime: ACTIVE_LIBRARY_STALE_TIME }), _b = _a.data, data = _b === void 0 ? EMPTY_ACTIVE_LIBRARY : _b, isLoading = _a.isLoading;
    return __assign(__assign({}, data), { isLoading: isLoading });
};
